import { $clientBrandProfiles } from './states';
import { fetchClientBrandProfiles } from './effects';

$clientBrandProfiles.on(fetchClientBrandProfiles.doneData, (_, data) => data);
